module.exports = __webpack_public_path__ + "img/19.4aa5aa31.jpg";